import * as VanillaMask from 'vanilla-masker';
import { isNullOrEmpty } from './../assets/js/function-utils';
import moment from 'moment';
import ENUM from '../consts/enum';

export const replaceCharacters = (value) => {
    value = value.toString();
    return value ? value.replace(/[^\d]/g, '') : '';
};

export const unmaskMoney = (value) => {
    if (value) {
        let valor = value.replace('R$', '');

        if (valor.includes(',')) {
            valor = valor.replace(/[.]/g, '');
            valor = valor.replace(',', '.');
        }

        return valor.trim();
    } else {
        return '';
    }
};

export const toCurrency = (value, currency) => {
    if (!isNullOrEmpty(value) && !isNaN(value)) {
        const integerPart = Number.parseInt(value).toLocaleString('pt-BR');
        let decimalNumber = Math.abs(value - Number.parseInt(value));
        /** Condição necessário: Pois 0.9965 por exemplo vira 1.00 e a parte decimal fica 00 incorretamente, invés de 99 */
        if (decimalNumber > 0.995) decimalNumber = 0.99;
        const decimalPart = decimalNumber.toFixed(2).substring(2);
        return `${currency || ''}${integerPart},${decimalPart}`;
    } else return null;
};

export const moneyPattern = (value) => {
    if (value) {
        let valor = unmaskMoney(value.toString());

        return VanillaMask.toMoney(valor, {
            // Decimal precision -> "90"
            precision: 2,
            // Decimal separator -> ",90"
            separator: ',',
            // Number delimiter -> "12.345.678"
            delimiter: '.',
            // Money unit -> "R$ 12.345.678,90"
            unit: 'R$',

            // Force type only number instead decimal,
            // masking decimals with ",00"
            // Zero cents -> "R$ 1.234.567.890,00"
            zeroCents: false
        });
    } else {
        return null;
    }
};

export const normalizeCep = (value) => {
    const onlyNums = value.replace(/[^\d]/g, '');
    let cep = '';
    if (onlyNums.length > 5) {
        cep = onlyNums.slice(0, 5);
        cep = cep + '-';
        cep = cep + onlyNums.slice(5, onlyNums.length);
    } else cep = onlyNums;
    return cep;
};

export const normalizeCpf = (value) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, '');

    if (onlyNums.length <= 3) {
        return onlyNums;
    }

    if (onlyNums.length <= 6) {
        return onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6);
    }

    if (onlyNums.length <= 9) {
        return onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6) + '.' + onlyNums.slice(6, 9);
    }

    if (onlyNums.length <= 11) {
        return (
            onlyNums.slice(0, 3) + '.' + onlyNums.slice(3, 6) + '.' + onlyNums.slice(6, 9) + '-' + onlyNums.slice(9, 11)
        );
    }
};

export const normalizeCnpj = (value) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[\^d]/g, '');

    if (onlyNums.length <= 2) {
        return onlyNums;
    }

    if (onlyNums.length <= 5) {
        return onlyNums.slice(0, 2) + '.' + onlyNums.slice(2, 5);
    }

    if (onlyNums.length <= 8) {
        return onlyNums.slice(0, 2) + '.' + onlyNums.slice(2, 5) + '.' + onlyNums.slice(5, 8);
    }

    if (onlyNums.length <= 12) {
        return (
            onlyNums.slice(0, 2) + '.' + onlyNums.slice(2, 5) + '.' + onlyNums.slice(5, 8) + '/' + onlyNums.slice(8, 12)
        );
    }

    if (onlyNums.length <= 14) {
        return (
            onlyNums.slice(0, 2) +
            '.' +
            onlyNums.slice(2, 5) +
            '.' +
            onlyNums.slice(5, 8) +
            '/' +
            onlyNums.slice(8, 12) +
            '-' +
            onlyNums.slice(12, 14)
        );
    }
};

export const normalizeCpfCnpj = (value, previousValue) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length <= 11) {
        return normalizeCpf(onlyNums, previousValue);
    } else {
        return normalizeCnpj(onlyNums, previousValue);
    }
};

export const validarCpf = (strCPF) => {
    strCPF = strCPF.replace(/[^\d]+/g, '');
    let Soma = 0;

    if (
        strCPF === '00000000000' ||
        strCPF === '11111111111' ||
        strCPF === '22222222222' ||
        strCPF === '33333333333' ||
        strCPF === '44444444444' ||
        strCPF === '55555555555' ||
        strCPF === '66666666666' ||
        strCPF === '77777777777' ||
        strCPF === '88888888888' ||
        strCPF === '99999999999'
    ) {
        return false;
    }

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    let Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);

    Resto = (Soma * 10) % 11;
    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

    return true;
};

export function validarCNPJ(cnpj) {
    if (cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');
        if (cnpj.length !== 14) return false;
        if (/^(\d)\1+$/.test(cnpj)) return false;

        let t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = (x) => {
                let n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0;

                for (let i = x; i >= 1; i--) {
                    s += n.charAt(x - i) * y--;
                    if (y < 2) y = 9;
                }

                r = 11 - (s % 11);
                return r > 9 ? 0 : r;
            };

        return calc(t) === d1 && calc(t + 1) === d2;
    } else {
        return cnpj;
    }
}

export const normalizePhone = (value) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length === 0) {
        return '';
    }
    if (onlyNums.length <= 2) {
        return '(' + onlyNums;
    }
    if (onlyNums.length <= 6) {
        return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 6);
    }
    if (onlyNums.length <= 10) {
        return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 6) + '-' + onlyNums.slice(6, 10);
    }
    return '(' + onlyNums.slice(0, 2) + ') ' + onlyNums.slice(2, 7) + '-' + onlyNums.slice(7, 11);
};

export const strCommaNumberToFloat = (value) => {
    return value ? parseFloat(value.toString().replace(/,/g, '.')) : value;
};

export const replaceDotToComma = (value) => value.toString().replace('.', ',');
export const replaceCommaToDot = (value) => value.toString().replace(',', '.');

export const onlyNumsComma = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9,]/g, '');
    const indexOfComma = numOnly.indexOf(',');
    const lastIndexOfComma = numOnly.lastIndexOf(',');
    if (indexOfComma !== lastIndexOfComma) {
        numOnly = numOnly.slice(0, lastIndexOfComma);
    }
    if (indexOfComma > -1) {
        numOnly = numOnly.slice(0, indexOfComma + 3);
    }
    if (indexOfComma === 0) {
        numOnly = '0,';
    }
    return numOnly;
};

export const onlyNumsDot = (value) => {
    let numOnly = replaceCommaToDot(value);
    numOnly = numOnly.replace(/[^0-9.]/g, '');
    const indexOfComma = numOnly.indexOf('.');
    const lastIndexOfComma = numOnly.lastIndexOf('.');
    if (indexOfComma !== lastIndexOfComma) {
        numOnly = numOnly.slice(0, lastIndexOfComma);
    }
    if (indexOfComma > -1) {
        numOnly = numOnly.slice(0, indexOfComma + 3);
    }
    if (indexOfComma === 0) {
        numOnly = '0.';
    }
    return numOnly;
};



export const onlyNumsDegreeLatitude = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9]/g, '');
    if (strCommaNumberToFloat(numOnly) > 90) {
        numOnly = '90';
    }
    if (strCommaNumberToFloat(numOnly) < 0) {
        numOnly = '0';
    }
    return numOnly;
};

export const onlyNumsDegreeLongitude = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9]/g, '');
    if (strCommaNumberToFloat(numOnly) >= 90) {
        numOnly = '180';
    }
    if (strCommaNumberToFloat(numOnly) < 0) {
        numOnly = '0';
    }
    return numOnly;
};

export const onlyNumsMin = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9]/g, '');
    if (strCommaNumberToFloat(numOnly) >= 60) {
        numOnly = '59';
    }
    if (strCommaNumberToFloat(numOnly) < 0) {
        numOnly = '0';
    }
    return numOnly;
};

export const onlySecondsComma = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9,]/g, '');
    const indexOfComma = numOnly.indexOf(',');
    const lastIndexOfComma = numOnly.lastIndexOf(',');
    if (indexOfComma !== lastIndexOfComma) {
        numOnly = numOnly.slice(0, lastIndexOfComma);
    }
    if (indexOfComma > -1) {
        numOnly = numOnly.slice(0, indexOfComma + 6);
    }
    if (indexOfComma === 0) {
        numOnly = '0,';
    }
    if (strCommaNumberToFloat(numOnly) >= 60) {
        numOnly = '59.99999';
    }
    if (strCommaNumberToFloat(numOnly) < 0) {
        numOnly = '0';
    }
    return numOnly;
};

export const onlyNums = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9]/g, '');
    return numOnly;
};

export const onlyNumsLetters = (value) => {
    const valueReturn = value.replace(/[^A-Za-z0-9]+/g, '');
    return valueReturn;
};

export const onlyAlphaNumericCharacters = (value) => {
    const valueReturn = value.replace(/[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ0-9 ]+/g, '');
    return valueReturn;
};

export const emptySpaces = (value) => {
    const valueReturn = value.replace(/[ ]+/g, '');
    return valueReturn;
};

export const testEmail = (value) => {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z0-9]{2,4}$/g.test(
        value
    );
};

export const onlyNumsLMI = (value) => {
    let numOnly = replaceDotToComma(value);
    numOnly = numOnly.replace(/[^0-9]/g, '');
    if (strCommaNumberToFloat(numOnly) >= 100) {
        numOnly = '100';
    }
    return numOnly;
};

export function normalizeData(value) {
    if (!value) return '-';
    return moment(value).format('DD/MM/YYYY');
}

export const appendZerosLeft = (value, max = 4) => {
    if (value) {
        if (value.length < max) {
            const zerosStr = new Array(max - value.length).fill(0).join('');
            return zerosStr + value;
        }
    }
    return value;
};

export function mapFormaPagamentoBeneficiario(formaPagamento) {
    if (formaPagamento === ENUM.TIPO_CONTA.CONTA_CORRENTE) {
        return 'Conta Corrente';
    } else if (formaPagamento === ENUM.TIPO_CONTA.CONTA_POUPANCA) {
        return 'Conta Poupança';
    } else {
        return 'N/A';
    }
}
